import { useTranslation } from 'react-i18next';

import { Header } from '../../../atoms/header/header';

import { CodeCaptureForm } from './code-capture-form';

const VerificationCodeStep = ({
  deliveryAddress,
  onSubmit,
  onResend,
}: {
  readonly deliveryAddress: string;
  readonly onSubmit: (code: string) => Promise<void>;
  readonly onResend: () => void | Promise<void>;
}) => {
  const { t } = useTranslation();
  return (
    <div className="form-container space-y-6 pt-6">
      <Header level="h2">{t('auth.accountVerification.code.title')}</Header>
      <CodeCaptureForm
        autoComplete="one-time-code"
        buttonLabel={t('common.buttons.submit')}
        description={t('auth.accountVerification.code.sent', { to: deliveryAddress })}
        errorRequired={t('auth.common.errors.confirmationCodeMissing')}
        inputMode="numeric"
        onRetry={onResend}
        onSubmit={onSubmit}
        placeholder={'000000'}
        showSupportContact
      />
    </div>
  );
};

export { VerificationCodeStep };
